import { ReactElement, useMemo } from 'react';
import { Typography } from '@mui/material';
import { ArrowBackIosNewRounded as ExpandMoreIcon } from '@mui/icons-material';
import classNames from 'classnames';

import { useDashboardVariantV2CarrierHeaderExpandMoreContext } from '../Context';

import {
  classes,
  DashboardVariantV2CarrierHeaderExpandMoreDividerContainer,
  DashboardVariantV2CarrierHeaderExpandMoreDividerButton,
} from './styles';

const DashboardVariantV2CarrierHeaderExpandMoreDivider = (): ReactElement => {
  const { expand, toggleExpand } =
    useDashboardVariantV2CarrierHeaderExpandMoreContext();

  const buttonLabel = useMemo(
    () => (expand ? 'Ver menos' : 'Ver más'),
    [expand],
  );

  return (
    <DashboardVariantV2CarrierHeaderExpandMoreDividerContainer>
      <DashboardVariantV2CarrierHeaderExpandMoreDividerButton
        onClick={() => toggleExpand()}
        className={classNames({ [classes.buttonExpanded]: expand })}
        endIcon={<ExpandMoreIcon />}
      >
        <Typography component="span" variant="inherit" color="inherit">
          {buttonLabel}
        </Typography>
      </DashboardVariantV2CarrierHeaderExpandMoreDividerButton>
    </DashboardVariantV2CarrierHeaderExpandMoreDividerContainer>
  );
};

export default DashboardVariantV2CarrierHeaderExpandMoreDivider;
